import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const FolderIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "folder",
  "FolderIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M0.666504 1.66669L6.32025 1.66669L7.65359 3.33335L15.3332 3.33335L15.3332 14L0.666504 14L0.666504 1.66669ZM1.99984 3.00002L1.99984 12.6667L13.9998 12.6667L13.9998 4.66669L7.01275 4.66669L5.67942 3.00002L1.99984 3.00002Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default FolderIcon;
